import { createFileRoute } from '@tanstack/react-router';
import { InvoiceFormPage } from '@/pages/Invoice/InvoiceFormPage';

export const Route = createFileRoute('/_admin/invoice/new')({
  component: InvoiceFormPage,
});
